(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vilros-education"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (!root || root.dataset.veReady === 'true') return;
    root.dataset.veReady = 'true';
    const mobile = root.querySelector('[data-ve-mobile]');
    const quote = root.querySelector('[data-ve-quote]');
    const firstAction = root.querySelector('[data-ve-cta="hero"]');
    if (!mobile || !quote || !firstAction || !('IntersectionObserver' in window)) return;
    let quoteVisible = false;
    let heroActionVisible = true;
    const query = window.matchMedia('(max-width: 760px)');
    const update = () => {
      mobile.hidden = !query.matches || quoteVisible || heroActionVisible || root.classList.contains('ve-inline');
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === quote) quoteVisible = entry.isIntersecting;
        if (entry.target === firstAction) heroActionVisible = entry.isIntersecting;
      });
      update();
    }, { rootMargin: '0px 0px 80px 0px', threshold: 0 });
    observer.observe(quote);
    observer.observe(firstAction);
    query.addEventListener('change', update);
    root.dataset.veEnhanced = 'true';
    const cleanup = (event) => {
      if (event.target.contains(root)) {
        observer.disconnect();
        query.removeEventListener('change', update);
        document.removeEventListener('shopify:section:unload', cleanup);
      }
    };
    document.addEventListener('shopify:section:unload', cleanup);
    update();
  };
  document.querySelectorAll('[data-ve-root]').forEach(initialize);
  if (!window.vilrosEducationSectionListener) {
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-ve-root]').forEach(initialize);
    });
    window.vilrosEducationSectionListener = true;
  }
})();


  } catch(e) { console.error(e); }
})();
})();
